import AssignmentNew from '@/components/homeworks/CreateAssignment'
import AssignmentLibrary from '@/components/homeworks/AssignmentLibrary'
import AssignmentLibraryDetail from '@/components/homeworks/AssignmentLibraryDetail'
import DuplicateAssignmentLibrary from '@/components/homeworks/DuplicateAssignmentLibrary'
import Assessments from '@/components/homeworks/Assessments'
import Scenarios from '@/components/scenario/Scenarios'

const homeWorksRoutes = [
  {
    path: '/organization/:organizationId/assignment/new',
    name: 'assignment-new',
    component: AssignmentNew,
    props: true,
    meta: {
      title: 'New Assignment',
    },
  },
  {
    path: "/organization/:organizationId/assignment-library/new",
    name: "assignment-library-new",
    component: AssignmentNew,
    props: true,
    meta: {
      menuItemIndex: '9',
      title: "New Assignment Library",
    },
  },
  {
    path: '/organization/:organizationId/assignment-library',
    name: 'assignment-library',
    component: AssignmentLibrary,
    props: true,
    meta: {
      menuItemIndex: '9',
      title: 'Assignment Library',
    },
  },
  {
    path: '/organization/:organizationId/assignment-library/:assignmentLibraryId',
    name: 'assignment-library-detail',
    component: AssignmentLibraryDetail,
    props: true,
    meta: {
      title: 'Assignment Library Detail',
    },
  },
  {
    path: '/organization/:organizationId/assignment-library/:assignmentLibraryId/duplicate',
    name: 'assignment-library-duplicate',
    component: DuplicateAssignmentLibrary,
    props: true,
    meta: {
      menuItemIndex: '9',
      title: 'Duplicate Assignment Library',
    },
  },
  {
    path: '/organization/:organizationId/assessments',
    name: 'assessments',
    component: Assessments,
    props: true,
    meta: {
      menuItemIndex: '9',
      title: 'Assessments',
    },
  },
  {
    path: '/organization/:organizationId/scenarios',
    name: 'scenarios',
    component: Scenarios,
    props: true,
    meta: {
      menuItemIndex: '9',
      title: 'Scenarios',
    },
  }
]

export default homeWorksRoutes
